import ApiService from "src/app/model/api/generic/apiService";

export default class VersionesService extends ApiService {

    public async getDescripcion(version: string): Promise<string> {
        return await this.service.HttpGet('/api/versiones/getdescripcion', {
            version: version
        })
    }

}